import { gql } from 'graphql-tag'
import { orderFieldsCMA } from './orderFieldsCMA'

export const GET_CONSUMER_ORDERS = gql`
  query getConsumerOrders($includePickups: Boolean = false) {
    orders: getConsumerOrders(includePickups: $includePickups) {
      ...OrderFieldsCMA
    }
  }
  ${orderFieldsCMA}
`
